import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";

function CoverLetter() {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/get-started");
  };

  return (
    <div style={{ padding: "40px", maxWidth: "1100px", margin: "0 auto" }}>

      <SEOHead
        title="Cover Letter"
        description="Build professional, ATS-friendly cover letters that communicate your value to employers. Create personalized cover letters in seconds with EmployPilot."
        canonical="https://employpilot.com/cover-letter"
      />


      {/* =======================================================
          HERO
      ======================================================= */}

      <h1
        style={{
          fontSize: "48px",
          fontWeight: "bold",
          textAlign: "center",
          lineHeight: "1.15"
        }}
      >
        Build a Professional Cover Letter That Gets You Noticed
      </h1>

      <p
        style={{
          textAlign: "center",
          fontSize: "18px",
          color: "#555",
          marginTop: "20px",
          maxWidth: "850px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: "1.8"
        }}
      >
        A great cover letter does more than introduce your resume.
        It communicates your professional value, connects your
        experience to the position, and helps employers understand
        why you are the right candidate. EmployPilot creates
        personalized cover letters that position your strengths
        with confidence and professionalism.
      </p>

      <div style={{ textAlign: "center" }}>
        <button onClick={handleStart} style={btnPrimary}>
          Build My Cover Letter Free
        </button>
      </div>

      {/* =======================================================
          EMPLOYPILOT DIFFERENCE
      ======================================================= */}

      <section style={{ marginTop: "80px" }}>

        <h2>Position Yourself as the Candidate They Want to Hire</h2>

        <p>
          Most applicants use a cover letter to explain why they
          want a job.
        </p>

        <p>
          EmployPilot takes a different approach.
        </p>

        <p>
          Every cover letter is built to position your experience,
          accomplishments, and professional strengths as valuable
          assets to an employer. Rather than relying on generic
          templates, EmployPilot creates personalized cover letters
          that connect your background directly to the employer's
          needs.
        </p>

        <p>
          Because the strongest candidates don't simply ask for an
          opportunity—they demonstrate why they're the right
          investment.
        </p>

      </section>

      {/* =======================================================
          WHY EMPLOYPILOT
      ======================================================= */}

      <section style={{ marginTop: "70px" }}>

        <h2>Why Professionals Choose EmployPilot</h2>

        <ul>

          <li>Personalized for every job description</li>

          <li>ATS-friendly formatting employers expect</li>

          <li>Professional writing focused on your value</li>

          <li>Personalized content instead of generic templates</li>

          <li>Designed to complement your resume</li>

          <li>Generate professional cover letters in seconds</li>

        </ul>

      </section>

      {/* =======================================================
          HOW IT WORKS
      ======================================================= */}

      <section style={{ marginTop: "70px" }}>

        <h2>How It Works</h2>

        <ol>

          <li>
            Paste the employer's job description.
          </li>

          <li>
            Describe your experience, education,
            certifications, and career goals.
          </li>

          <li>
            EmployPilot generates a personalized
            professional cover letter.
          </li>

          <li>
            Review, personalize, and confidently
            submit your application.
          </li>

        </ol>

      </section>

      {/* =======================================================
          INDUSTRIES
      ======================================================= */}

      <section style={{ marginTop: "70px" }}>

        <h2>Professional Cover Letters For Every Industry</h2>

        <p>
          Whether you're entering the workforce,
          changing careers, or pursuing leadership
          opportunities, EmployPilot creates professional
          cover letters for nearly every profession.
        </p>

        <ul>

          <li>Engineering</li>

          <li>Healthcare</li>

          <li>Information Technology</li>

          <li>Manufacturing</li>

          <li>Skilled Trades</li>

          <li>Finance</li>

          <li>Business Administration</li>

          <li>Education</li>

          <li>Government</li>

          <li>Retail & Customer Service</li>

        </ul>

      </section>

      {/* =======================================================
          FAQ
      ======================================================= */}

      <section style={{ marginTop: "70px" }}>

        <h2>Frequently Asked Questions</h2>

        <h3>How long does it take?</h3>

        <p>
          Most cover letters are generated in
          under ten seconds.
        </p>

        <h3>Can I edit my cover letter?</h3>

        <p>
          Yes. Every generated cover letter can be
          personalized before applying.
        </p>

        <h3>Does EmployPilot work with ATS systems?</h3>

        <p>
          Yes. Every cover letter follows modern,
          recruiter-friendly formatting.
        </p>

        <h3>Can I use EmployPilot for any career?</h3>

        <p>
          Absolutely. EmployPilot adapts to virtually
          every profession and experience level.
        </p>

      </section>

      {/* =======================================================
          CTA
      ======================================================= */}

      <section
        style={{
          marginTop: "80px",
          padding: "40px",
          backgroundColor: "#f8f9fa",
          borderRadius: "12px",
          textAlign: "center"
        }}
      >

        <h2>
          Ready To Build Your Cover Letter?
        </h2>

        <p
          style={{
            maxWidth: "700px",
            margin: "20px auto",
            color: "#666"
          }}
        >
          Create a personalized cover letter that
          communicates your value, highlights your
          experience, and positions you as the
          candidate employers want to hire.
        </p>

        <button onClick={handleStart} style={btnPrimary}>
          Get Started Free
        </button>

      </section>

      {/* =======================================================
          FOOTER
      ======================================================= */}

      <div
        style={{
          marginTop: "80px",
          textAlign: "center",
          fontSize: "14px",
          color: "#777",
          borderTop: "1px solid #eee",
          paddingTop: "30px"
        }}
      >
        © 2026 EmployPilot. All Rights Reserved.

        <div style={{ marginTop: "10px" }}>
          <Link to="/terms" style={{ margin: "0 10px" }}>
            Terms of Use
          </Link>

          <Link to="/privacy" style={{ margin: "0 10px" }}>
            Privacy Policy
          </Link>

          <Link to="/contact" style={{ margin: "0 10px" }}>
            Contact
          </Link>
        </div>
      </div>

    </div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px",
  fontWeight: "bold"
};

export default CoverLetter;